import React from 'react';
import { ThreeColumnListings } from '../ThreeColumnListings';
import PropTypes from 'prop-types';
import AlertMessage from '../../../../../components/AlertMessage';
import { THREE_COL_SIMILAR_LISTINGS_CONTAINER } from '../../../../../utils/domParserHelper';

const LIMIT_LISTINGS_COUNT = 5;

const SimilarBoatListings = ({
  similarListings,
  teaserRate,
  locale,
  formatMessage,
  messages,
  tracking,
  adParams,
  setListingClick,
  cookies,
  customUom,
  userCurrency,
  isLoading,
  newPageAdsConfig,
  listingsCount,
  containerDataId = THREE_COL_SIMILAR_LISTINGS_CONTAINER
}) => {
  if (!(similarListings?.length > 0) || listingsCount > LIMIT_LISTINGS_COUNT) {
    return null;
  }
  let title = formatMessage(messages.additionalLeads.similarBoats);
  let description = formatMessage(messages.alertMessage.similarBoatsForOEMs.description);
  if (listingsCount === 0) {
    title = formatMessage(messages.alertMessage.similarBoatsForOEMs.title);
  }
  return (
    <div data-e2e="similar-boat-listings" className="similar-boat-listings">
      <AlertMessage
        mainText={title}
        secondaryText={description}
      />
      <ThreeColumnListings
        listings={similarListings}
        teaserRate={teaserRate}
        locale={locale}
        formatMessage={formatMessage}
        adParams={adParams}
        tracking={tracking}
        setListingClick={setListingClick}
        cookies={cookies}
        customUom={customUom}
        userCurrency={userCurrency}
        isLoading={isLoading}
        newPageAdsConfig={newPageAdsConfig}
        containerDataId={containerDataId}
      />
    </div>
  );
};

SimilarBoatListings.propTypes = {
  similarListings: PropTypes.array,
  teaserRate: PropTypes.number,
  locale: PropTypes.string,
  formatMessage: PropTypes.func,
  tracking: PropTypes.object,
  setListingClick: PropTypes.func,
  cookies: PropTypes.object.isRequired,
  customUom: PropTypes.string,
  userCurrency: PropTypes.string,
  isLoading: PropTypes.bool,
  newPageAdsConfig: PropTypes.object,
  messages: PropTypes.object,
  listingsCount: PropTypes.number,
  adParams: PropTypes.object,
  containerDataId: PropTypes.string,
};

export {SimilarBoatListings, LIMIT_LISTINGS_COUNT};
